import React, { useContext, useEffect, useState } from 'react'
import styles from './LbGsGoToDashboard.module.css'
import { motion } from 'framer-motion'
import { FaExternalLinkAlt } from 'react-icons/fa'
import { Link, useParams } from 'react-router'
import AuthContext from '../../store/auth-context'
import ActiveStoreContext from '../../store/ActiveStoreContext'
import { BASE_URL_API } from '../../References/URLs'
import { get } from 'lodash'

const LbGsGoToDashboard = () => {
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext)
    const activeStore = (() => { try { return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const vendorIdentifier = JSON.parse(authCtx?.loginData)?.partnersData?.vendorIdentifier
    const { token } = useParams()
    const [tokenData, setTokenData] = useState({ formIdentifier: token })
    const [copied, setCopied] = useState(false)

    const lb_getIndividualToken = async () => {
        const getIndividualTokenResponse = await fetch(BASE_URL_API + "lb_getIndividualToken",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    formIdentifier: token
                })
            });

        if (!getIndividualTokenResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const getIndividualTokenRespo = await getIndividualTokenResponse.json()
            if (getIndividualTokenRespo.status === "success") {
                setTokenData(getIndividualTokenRespo?.response)
            } else {
                if (getIndividualTokenRespo.message === "tokenExpired") {
                    authCtx.logout()
                }
                console.log(getIndividualTokenRespo)
            }
        }
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(tokenData?.token || '')
        setCopied(true)
        setTimeout(() => setCopied(false), 2000)
    }
    

    useEffect(() => {
        lb_getIndividualToken()
    }, [token])



    if (activeStore === null) {
        return (
            <div className={styles.mainWrapper}>
                <div className={styles.mainContainer}>
                    <div className={styles.mainContent}>
                        Please select a store!
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={styles.goToDashboardContainer}>
            <div className={styles.pageHeader}>
                <Link to={`/leadbridge`} className={styles.phlWrapper}>
                    LeadBridge™
                </Link>
                <div className={styles.phrWrapper}>
                    <Link to={`/leadbridge/dashboard`}>
                        Go To Dashboard
                    </Link>
                    <Link to={`/leadbridge/help`}>
                        Help
                    </Link>
                </div>
            </div>
            <div className={styles.pageBody}>
                <motion.div
                    className={styles.contentBox}
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <h1>You're All Set!</h1>
                    <div className={styles.subtext}>Your {tokenData?.formName} form can now be connected with CRM and ready to capture leads.</div>

                    <div className={styles.resources}>
                        <h3>🔧 Quick Setup Tips:</h3>
                        <ul>
                            <li>Copy & paste the generated token into your website's form ({tokenData?.pageUrl}) script.</li>
                            <li>Monitor submissions live from your CRM dashboard.</li>
                            <li>Need help? Reach out via support tab inside CRM.</li>
                        </ul>
                    </div>

                    <div className={styles.tokenPreview}>
                        <h4>📌 Integration Token:</h4>
                        <div className={styles.tokenRow}>
                            <code>{tokenData?.token}</code>
                            <button className={styles.copyBtn} onClick={handleCopy}>
                                {copied ? "Copied!" : "Copy"}
                            </button>
                        </div>
                    </div>


                    <div>
                        <div className={styles.createdOn}>
                            Created On : {tokenData?.createdOn}
                        </div>
                    </div>

                    <div className={styles.ctaButtons}>
                        <Link to={"/leadbridge/dashboard"} className={styles.primaryBtn}>
                            Go to Dashboard <FaExternalLinkAlt style={{ marginLeft: '8px' }} />
                        </Link>
                    </div>
                </motion.div>
            </div>
        </div>
    )
}

export default LbGsGoToDashboard
